import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import {Button, Card} from "react-bootstrap";
import BlogReader from "../../Components/Blog/BlogReader";

//
function BlogPage() {
    return (<>
        <Navbar/>
        <Card>
            <Card.Header><Card.Title>TSC Blog</Card.Title></Card.Header>
                <BlogReader></BlogReader>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>)

}

export default BlogPage;